export class UserRestEndPoints {

  public static NEW_GTLD_LOGIN = '/newGtldLogin';
  public static GET_LIST_OF_UNDELEGTED_DOMAINS: string = '/domains/undelegated';

}
